var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32 0C1.93412 0 0 1.93413 0 4.32V31.68C0 34.0659 1.93412 36 4.32 36H31.68C34.0659 36 36 34.0659 36 31.68V4.32C36 1.93413 34.0659 0 31.68 0H4.32Z",
    fill: "#363497"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 10.2H7.19998C6.86998 10.2 6.59998 10.47 6.59998 10.8V25.2C6.59998 25.53 6.86998 25.8 7.19998 25.8H28.8C29.13 25.8 29.4 25.53 29.4 25.2V10.8C29.4 10.47 29.13 10.2 28.8 10.2ZM10.8 24.6H7.79998V22.2H10.8V24.6ZM10.8 21H7.79998V18.6H10.8V21ZM10.8 17.4H7.79998V15H10.8V17.4ZM10.8 13.8H7.79998V11.4H10.8V13.8ZM24 24.6H12V11.4H24V24.6ZM28.2 24.6H25.2V22.2H28.2V24.6ZM28.2 21H25.2V18.6H28.2V21ZM28.2 17.4H25.2V15H28.2V17.4ZM28.2 13.8H25.2V11.4H28.2V13.8Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18L15 21.4641L15 14.5359L21 18Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileVideo);
export default __webpack_public_path__ + "static/media/file-video.ab706395bf5dea800d89623c807b3ff4.svg";
export { ForwardRef as ReactComponent };